import { render } from "./YellowEditSustainable.vue?vue&type=template&id=13c1cdbc"
import script from "./YellowEditSustainable.vue?vue&type=script&lang=js"
export * from "./YellowEditSustainable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__